import { formatBiValue } from '@euler/model/bi/format';
import { BiQueryResult } from '@euler/model/bi/result';
import { BiKpiGroupViz } from '@euler/model/bi/viz';
import { biColumnLookup } from './biColumns';
import { BiTableModel } from './biResultTable';
import { biText } from './biText';

/**
 * A KPI group's table: a row per number, its name and value. The numbers
 * measure different things, so the totals row stays blank. Null when an
 * item's column is missing from the result.
 */
export function biTableOfKpiGroup(
  viz: BiKpiGroupViz,
  result: BiQueryResult,
): BiTableModel | null {
  const rows = viz.items.map(item => {
    const formats = item.format ? { [item.value]: item.format } : undefined;
    const ref = biColumnLookup(result, formats)(item.value);
    if (!ref) return null;
    const value = result.rows[0]?.[ref.index] ?? null;
    return {
      name: item.name ?? biText(ref.column.label),
      value,
      display: formatBiValue(value, ref.format),
    };
  });
  if (rows.some(row => row === null)) return null;
  const read = rows as NonNullable<(typeof rows)[number]>[];
  const header = ['指标', '数值'];
  return {
    header,
    body: read.map(row => [row.name, row.display]),
    raw: read.map(row => [row.name, row.value]),
    align: ['left', 'right'],
    totals: header.map(() => ''),
  };
}
